var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLatte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 288 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#765638;stroke-linejoin:round;stroke-width:6px;fill:url(#linear-gradient);}.cls-2{fill:none;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 137,
    y1: 210.5,
    x2: 137,
    y2: 97.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c69c6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#c79d6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#c9a276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ceaa81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d5b592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ddc4a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#e8d7c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#f4ece3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.5,97.5q1,8.3,2.17,16.78c-3.9-2.88-8.68-5-13.58-3.93-3.88.88-9.34,4.22-13.24,15.11A42.28,42.28,0,0,0,73.36,157c6.83,15.42,22.79,28.15,36.66,29.68q2.19,12.17,4.48,23.87h72q4.71-24.1,9-50.22,5.31-32.55,9-62.78ZM82.72,148.89c-2.59-5.85-2.93-11.27-1-16.57,2.2-6.14,4.42-6.65,5.15-6.82a4.5,4.5,0,0,1,1-.1c3.86,0,8.6,4.67,11,7.58l6.65,37.07C96.41,166.8,86.89,158.3,82.72,148.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 288,
    height: 288
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatte);
export default __webpack_public_path__ + "static/media/latte.c818ba0865f04210dd1cc9b638999a7b.svg";
export { ForwardRef as ReactComponent };